export default __webpack_public_path__ + "assets/Suntrust-7491b951370de21bdec60779762dd8c2.svg";